import { COLOR_PALETTE } from 'constants/ui';

export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  padding: '24px',
  gap: '20px',
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const callerInfoStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px',
};

export const callerNameStyles = {
  fontSize: '20px',
  fontWeight: 600,
  color: ({ palette }) => palette.text.strong,
};

export const timerStyles = {
  fontSize: '32px',
  fontWeight: 500,
  color: ({ palette }) => palette.text.strong,
  fontVariantNumeric: 'tabular-nums',
};

export const controlRowStyles = {
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
};

export const controlButtonStyles = {
  width: 48,
  height: 48,
  borderRadius: '50%',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.paper,
  color: ({ palette }) => palette.text.secondary,
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

export const controlButtonActiveStyles = {
  ...controlButtonStyles,
  backgroundColor: COLOR_PALETTE.BRAND[6],
  color: '#fff',
  '&:hover': {
    backgroundColor: COLOR_PALETTE.BRAND[7],
  },
};

export const hangupButtonStyles = {
  width: 64,
  height: 64,
  borderRadius: '50%',
  backgroundColor: COLOR_PALETTE.RED[6],
  color: '#fff',
  '&:hover': {
    backgroundColor: COLOR_PALETTE.RED[7],
  },
};

export const dtmfGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '4px',
  justifyItems: 'center',
};

export const dtmfButtonStyles = {
  width: 40,
  height: 40,
  minWidth: 40,
  borderRadius: '50%',
  fontSize: '16px',
  fontWeight: 500,
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.paper,
  color: ({ palette }) => palette.text.strong,
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};
